import { Component, OnInit, Signal, computed, effect, inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, ReactiveFormsModule, FormsModule, Form, FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';

import { AuthService } from '../../auth.service';

import { AccountService } from '../../account.service';
import { CommonModule, Location } from '@angular/common';

import { takeUntilDestroyed, toObservable, toSignal } from '@angular/core/rxjs-interop';
import { catchError, interval, map, Observable, of, scan, startWith, switchMap, tap, filter, combineLatest} from 'rxjs';
import { TuiInputModule } from '@taiga-ui/legacy';
import { TuiButton, TuiError, TuiTextfield } from '@taiga-ui/core';
import { environment } from '../../../../environments/environment';
import { CustomValidators } from '../../../shared/extensions/CustomValidators';
import {TUI_VALIDATION_ERRORS, TuiFieldErrorPipe} from '@taiga-ui/kit';
import { tuiIsFalsy } from '@taiga-ui/cdk/utils/miscellaneous';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ActionPortalDirective } from 'app/admin/features/action-portal/directives/action-portal.directive';
import { NavigationService } from 'app/Auth/navigation.service';
import {formValues} from 'app/shared/utils/form.utils';
import { signalSlice } from 'ngxtension/signal-slice';
import { injectQueryParams } from 'ngxtension/inject-query-params';
import { filterNil } from 'ngxtension/filter-nil';
import { PasswordComplexityDirective } from 'app/shared/features/password-complexity.directive';
import { toast } from 'ngx-sonner';



@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css'],
  imports: [
    CommonModule,
    TuiInputModule,
    TuiTextfield,
    TuiError,
    ReactiveFormsModule,
    TuiFieldErrorPipe,
    FormsModule,
    TuiButton,
    FontAwesomeModule,
    RouterModule,
    PasswordComplexityDirective
  ],
  providers: [
    {
      provide: TUI_VALIDATION_ERRORS,
      useValue: {
        notMatched: 'Your passwords do not match!',
        required: 'Required!',
        maxlength: ({ requiredLength }: { requiredLength: string }) => `Maximum length — ${requiredLength}`,
        minlength: ({ requiredLength }: { requiredLength: string }) => of(`Minimum length — ${requiredLength}`),
        min: interval(2000).pipe(
          scan(tuiIsFalsy, false),
          map((val) => (val ? 'Fix please' : 'Min number 3')),
          startWith('Min number 3')
        ),
      },
    },
  ],
})
export class ResetPasswordComponent implements OnInit {
  private readonly router: Router = inject(Router);

  email = injectQueryParams('email');
  token = injectQueryParams('token');


  email$ = toObservable(this.email).pipe(filterNil());
  token$ = toObservable(this.token).pipe(filterNil());

  form = new FormGroup({
    password: new FormControl<string>('', {
      validators: [  CustomValidators.passwordHasUpper,
        CustomValidators.minLength(8),
        CustomValidators.passwordHasSpecial,
        CustomValidators.required,]
    }),
    repeatPassword: new FormControl('', {validators: [CustomValidators.required]})
  },  { validators: [CustomValidators.passwordsMatch('password', 'repeatPassword')] })


  initialFormState = {
    ...this.form.getRawValue(),
    token: '' as string,
    email: '' as string,
    status: 'loading' as
      | 'loading'
      | 'loaded'
      | 'submitting'
      | 'success'
      | 'error',
  };


  formState = signalSlice({
    initialState: this.initialFormState,
    sources: [
      formValues(this.form),
      combineLatest([this.email$, this.token$]).pipe(map(([email, token]) => ({email, token, status: 'loaded' as const})))
    ],
    selectors: (state) => ({
    }),
    actionSources: {
      submit: (_, action$: Observable<void>) =>
        action$.pipe(
          map(() => ({token: _().token, password: _().password, email: _().email})),
          filter((model) => model.password != null),
          switchMap((model) =>
            this.accountService.resetPasswordWithToken({...model} as passwordResetToken).pipe(
              map(() => ({ status: 'success' as const })),
              catchError(() => of({ status: 'error' as const })),
              startWith({ status: 'submitting' as const })
            )
          )
        ),
    },
  });


  constructor(private route: ActivatedRoute, private accountService: AccountService) {




    effect(() => {
      const status = this.formState.status();

      if(status != 'loaded')
        this.form.disable();


      this.form.enable();
    })


    this.formState.status$.pipe(takeUntilDestroyed()).subscribe((status) => {
            if (status === 'success') {
              toast.success('Save Successful');
              this.router.navigate(['/login'])
            } else if (status === 'error') {
              toast.error('An Error Occurred');
            }
          });


  }

  ngOnInit(): void {}
}



export class passwordResetToken {
  token:string = ''
  email:string = ''
  password:string = ''
}
